export default __webpack_public_path__ + "static/media/Heart_Icon.a02c2bb6.svg";